import { HeaderNotificationRowItemResponse } from '../../../../../components/blackrock/advisor-center/_types/header.ts';

export type OrderedNotifications = {
	latest: HeaderNotificationRowItemResponse[];
	lastWeek: HeaderNotificationRowItemResponse[];
	lastMonth: HeaderNotificationRowItemResponse[];
};

const getDateXDaysAgo = (daysAgo: number) => {
	const today = new Date();
	return new Date(new Date().setDate(today.getDate() - daysAgo));
};

const getNotificationsBetweenDays = (
	daysBackFromTodayUpperBoundary: number, //inclusion
	daysBackFromTodayLowerBoundary: number, //inclusion
	notifications: HeaderNotificationRowItemResponse[]
): HeaderNotificationRowItemResponse[] => {
	const upperBoundaryDate = getDateXDaysAgo(daysBackFromTodayUpperBoundary);

	const lowerBoundaryDate = getDateXDaysAgo(daysBackFromTodayLowerBoundary);

	return notifications.filter((notification) => {
		const notificationDate = new Date(notification.timestamp);
		return (
			notificationDate >= lowerBoundaryDate &&
			notificationDate <= upperBoundaryDate
		);
	});
};

const orderNotificationsInTimeSpans = (
	notifications: null | HeaderNotificationRowItemResponse[]
): null | OrderedNotifications => {
	if (!notifications) {
		return null;
	}

	const latest = getNotificationsBetweenDays(0, 7, notifications);
	const lastWeek = getNotificationsBetweenDays(8, 14, notifications);
	const lastMonth = getNotificationsBetweenDays(15, 30, notifications);

	return {
		latest,
		lastWeek,
		lastMonth,
	};
};

export default orderNotificationsInTimeSpans;
